import React, { useCallback } from 'react';
import { Checkbox, Inscription } from '@common-fe/common-fe';

import useMFAStore from '@/modules/user/components/SignIn/MultiFactorAuthentication/stores/useMFA.store';

interface Props {
  testId?: string;
}

const RememberMeCheckbox: React.FC<Props> = ({ testId }) => {
  const { isRememberMe, setIsRememberMe } = useMFAStore();

  const handleSetIsRememberMe = useCallback(() => {
    setIsRememberMe(!isRememberMe);
  }, [setIsRememberMe, isRememberMe]);

  return (
    <Checkbox
      checked={isRememberMe}
      onChange={handleSetIsRememberMe}
    >
      <Inscription
        data-testId={`${testId}_remember-this-device-checkbox`}
        onClick={handleSetIsRememberMe}
        size="medium"
      >
        Remember this device
      </Inscription>
    </Checkbox>
  );
};

export default RememberMeCheckbox;
